/**
 * Unauthorized Page
 * 
 * Feature: 033-auth-complete
 * Description: 403 Forbidden error page
 * Constitution: v1.11.0
 */

import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

export const Unauthorized: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state as { requiredRole?: string; requiredPermission?: string } | null;

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50 dark:bg-gray-900">
      <div className="max-w-md w-full bg-white dark:bg-gray-800 shadow-lg rounded-lg p-8 text-center">
        <div className="mb-6">
          <div className="mx-auto w-16 h-16 bg-red-100 dark:bg-red-900/30 rounded-full flex items-center justify-center">
            <svg
              className="w-10 h-10 text-red-600"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
              />
            </svg>
          </div>
        </div>

        <h1 className="text-2xl font-bold text-gray-900 dark:text-gray-100 mb-2">Access Denied</h1>
        <p className="text-gray-600 dark:text-gray-400 mb-6">
          You don't have permission to access this resource.
        </p>

        {state?.requiredRole && (
          <div className="bg-yellow-50 dark:bg-yellow-900/20 border border-yellow-200 dark:border-yellow-800 rounded p-4 mb-6 text-left">
            <p className="text-sm text-yellow-800 dark:text-yellow-300">
              <strong>Required role:</strong> <span className="capitalize">{state.requiredRole}</span>
            </p>
            <p className="text-xs text-yellow-600 dark:text-yellow-400 mt-1">
              Contact your administrator to request access.
            </p>
          </div>
        )}

        {state?.requiredPermission && (
          <div className="bg-yellow-50 dark:bg-yellow-900/20 border border-yellow-200 dark:border-yellow-800 rounded p-4 mb-6 text-left">
            <p className="text-sm text-yellow-800 dark:text-yellow-300">
              <strong>Required permission:</strong> {state.requiredPermission}
            </p>
            <p className="text-xs text-yellow-600 dark:text-yellow-400 mt-1">
              Contact your administrator to request this permission.
            </p>
          </div>
        )}

        <div className="flex flex-col space-y-3">
          <button
            onClick={() => navigate(-1)}
            className="px-4 py-2 bg-gray-200 dark:bg-gray-700 text-gray-800 dark:text-gray-100 rounded hover:bg-gray-300 dark:hover:bg-gray-600 transition"
          >
            Go Back
          </button>
          <button
            onClick={() => navigate('/')}
            className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition"
          >
            Go to Home
          </button>
        </div>
      </div>
    </div>
  );
};
